import Button from "@shared/v2/Button";
import { AccountProduct } from "./types";
import Modal from "@shared/v2/Modal";

interface DeleteAccountProductModalProps {
  accountProduct?: AccountProduct;
  onDelete: (accountProduct: AccountProduct) => void;
  onClose: () => void;
}

const DeleteAccountProductModal: React.FC<DeleteAccountProductModalProps> = ({
  accountProduct,
  onClose,
  onDelete,
}) => (
  <Modal
    show={Boolean(accountProduct)}
    onHide={onClose}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[480px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    {/* @ts-expect-error props */}
    <Modal.Header
      title={`Delete ${accountProduct?.product.name}?`}
      description="This action cannot be undone."
      closeButton
    />
    <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
      {/* @ts-expect-error props */}
      <Button schema="secondary" onClick={onClose}>
        Cancel
      </Button>
      {/* @ts-expect-error props */}
      <Button
        schema="warning"
        onClick={() => {
          onDelete(accountProduct);
          onClose();
        }}
      >
        Delete
      </Button>
    </Modal.Footer>
  </Modal>
);

export default DeleteAccountProductModal;
